import BookColor from './BookColour.svg';
import BookDark from './BookDark.svg';
import BookLight from './BookLight.svg';
export const book = { color: BookColor, dark: BookDark, light: BookLight };
//# sourceMappingURL=index.js.map